<template>
  <div
    class="blog-item-container"
    :class="article.params.bloggers_post ? 'bloggers-post' : ''"
  >
    <div class="item carousel">
      <a
        class="img-wrapper"
        :style="imgstyle"
        :href="article.url"
        target="_blank"
        @click="emit('goArticle')"
      >
        <div class="img-wrapper-padding">
          <div class="article-title heading-s">
            {{
              article.title
                .replace(/\s/gi, 'sdvkhjbsknmf')
                .replace(/sdvkhjbsknmf/gi, ' ')
            }}
          </div>
          <div v-if="article.params.bloggers_post" class="article-blogger-info">
            <div
              class="bloggers-avatar"
              :style="`background: url('${article.params.bloggers_info?.bloggers_avatar}') center / contain no-repeat`"
            >
              <img
                src="/static/images/icon/youtube_icon.svg"
                alt="18+"
                class="youtube_icon"
              />
            </div>
            <div class="bloggers_name body-m-regular">
              {{ article.params.bloggers_info?.bloggers_name }}
            </div>
            <div class="bloggers-description body-s-regular">
              {{ article.params.bloggers_info?.bloggers_description }}
            </div>
          </div>
          <div v-if="!article.params.bloggers_post" class="article-info">
            <span class="article-info-item time-to-read body-s-regular"
              >{{ article.params.reading_time }}&nbsp;мин</span
            >
            <span class="article-info-item body-s-regular">{{
              article.params.views
            }}</span>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { BlogArticle } from '~/interfaces/api';

const emit = defineEmits(['goArticle']);

const props = defineProps({
  article: {
    type: Object as () => BlogArticle,
    default: () => {},
  },
});
const imgstyle = computed(() => {
  const background =
    'background: linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%) ';
  if (!props.article.params.image) return background;
  return `${background}, url(${props.article.params.image}), lightgray 50%`;
});
// \u00a0 = &nbsp;
</script>
<style lang="scss" scoped>
.blog-item-container {
  position: relative;
  //padding: 0 4px;
  //
  //@include md-block {
  //  padding: 0 6px;
  //}
  //
  //@include lg-block {
  //  padding: 0 8px;
  //}

  //&:first-child {
  //  padding-left: 0;
  //}
  //&:last-child {
  //  padding-right: 0;
  //}

  &.bloggers-post {
    .img-wrapper-padding {
      background: linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0) 45%);
    }
  }

  .item {
    background-color: $achromatic-card-bg;
    border-radius: 8px;
    padding: 0;
    position: relative;
    cursor: pointer;
    width: 196px;
    height: 236px;

    @include md-block {
      width: 226px;
      height: 272px;
    }
    @include lg-block {
      width: 224px;
    }
    @include xl-block {
      width: 226px;
    }
    @include xxl-block {
      width: 268px;
      height: 340px;
    }

    &:first-child {
      padding-left: 0 !important;
    }

    &:last-child {
      padding-right: 0 !important;
    }

    .img-wrapper {
      display: block;
      height: 100%;
      background-position: center !important;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      border-radius: 8px;

      .img-wrapper-padding {
        position: relative;
        padding: 12px 16px;
        height: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        @include md-block {
          padding: 20px 24px;
        }
        @include xxl-block {
          padding: 28px 32px;
        }

        .article-info {
          position: absolute;
          bottom: 0;
          display: flex;
          gap: 12px;
          margin-bottom: 12px;
          @include md-block {
            margin-bottom: 20px;
          }
          @include xxl-block {
            margin-bottom: 30px;
          }

          .article-info-item {
            padding-left: 15px;
            position: relative;
            color: $achromatic-hover;

            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              mask: url('/static/images/icon/page-views.svg') center / contain
                no-repeat;
              width: 12px;
              height: 9px;
              color: $achromatic-hover;
              background: $achromatic-hover;
              margin-top: 3px;
              @include xl-block {
                margin-top: 0;
                width: 12px;
                height: 14px;
              }
            }

            &.time-to-read {
              padding-left: 13px;

              &:before {
                width: 9px;
                height: 12px;
                margin-top: 1px;
                mask: url('/static/images/icon/stopwatch.svg') center / contain
                  no-repeat;
              }
            }
          }
        }

        .article-title {
          color: $white;
          word-break: break-word;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 5;
        }

        .article-blogger-info {
          flex-grow: 1;
          width: 100%;
          display: flex;
          flex-direction: column;
          color: $white;
          justify-content: flex-end;

          .bloggers_name {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 1;
          }

          .bloggers-description {
            margin-top: 2px;
            color: $achromatic-dots;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -webkit-line-clamp: 2;
            height: 32px;
            @include xl-block {
              margin-top: 4px;
            }
          }

          .bloggers-avatar {
            border-radius: 21px;
            width: 32px;
            margin-bottom: 4px;
            height: 32px;
            border: 1px solid white;
            position: relative;

            img.youtube_icon {
              position: absolute;
              top: -2px;
              right: 0;
              width: 12px;
            }

            @include md-block {
              width: 38px;
              height: 38px;
              img.youtube_icon {
                width: 14px;
              }
            }
            @include xxl-block {
              width: 42px;
              height: 42px;
              img.youtube_icon {
                width: 16px;
              }
            }
          }
        }
      }
    }
  }

  .half-opacity {
    opacity: 0.5;
  }
}
</style>
